import { z } from 'zod';
import { UUIDSchema } from '../ids.js';
export const TenantStatus = z.enum(['active', 'suspended', 'archived']);
export const Tenant = z.object({
    id: UUIDSchema,
    name: z.string(),
    contact_email: z.string().email().nullable(),
    contact_name: z.string().nullable().optional(),
    contact_phone: z.string().nullable().optional(),
    notes: z.string().nullable().optional(),
    status: TenantStatus,
    created_at: z.string().datetime(),
});
export const CreateTenantBody = z.object({
    name: z.string().min(1).max(120),
    contact_email: z.string().email().max(254).nullable().optional(),
    contact_name: z.string().max(120).nullable().optional(),
    contact_phone: z.string().max(40).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
});
export const UpdateTenantBody = z.object({
    name: z.string().min(1).max(120).optional(),
    contact_email: z.string().email().max(254).nullable().optional(),
    contact_name: z.string().max(120).nullable().optional(),
    contact_phone: z.string().max(40).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
    status: TenantStatus.optional(),
});
export const HardwareResourceType = z.enum(['door', 'door_group', 'device']);
export const BuildingResourceRow = z.object({
    id: UUIDSchema,
    unifi_resource_type: HardwareResourceType,
    unifi_resource_id: z.string().min(1).max(120),
    unifi_door_id: z.string().min(1).max(120).nullable(),
    unifi_door_group_id: z.string().min(1).max(120).nullable(),
    unifi_device_id: z.string().min(1).max(120).nullable(),
    name: z.string().min(1).max(200),
    full_name: z.string().max(300).nullable(),
    metadata_json: z.unknown(),
    first_seen_at: z.string().datetime(),
    last_seen_at: z.string().datetime(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
export const TenantResourceGrantRow = z.object({
    id: UUIDSchema,
    tenant_id: UUIDSchema,
    building_resource_id: UUIDSchema,
    label_override: z.string().max(120).nullable(),
    enabled: z.boolean(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
export const CreateTenantResourceGrantBody = z.object({
    tenant_id: UUIDSchema,
    building_resource_id: UUIDSchema,
    label_override: z.string().max(120).nullable().optional(),
});
export const ListTenantResourceGrantsQuery = z.object({
    tenant_id: UUIDSchema.optional(),
    building_resource_id: UUIDSchema.optional(),
});
//# sourceMappingURL=tenant.js.map